export default __webpack_public_path__ + "static/AliEskini-05e9f8f743f2d4d392fc21b68a85c4d9.png";